import { fabric } from 'fabric'

var extend = fabric.util.object.extend,
    filters = fabric.Image.filters,
    createClass = fabric.util.createClass;

// 默认状态下fabric的问题size太小，导致filter有问题
// https://stackoverflow.com/questions/51483856/fabricjs-cant-apply-filters-to-large-image-due-to-max-texture-size
if (fabric.isWebglSupported()) {
    // fabric.textureSize = fabric.maxTextureSize;
    // 最大设置为4096，太大会导致第一次applyFilters很慢
    fabric.textureSize = Math.min(4096, fabric.maxTextureSize)
}

filters.ReplaceColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.ReplaceColor.prototype */ {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'ReplaceColor',
    /**
     * Color to remove, in any format understood by fabric.Color.
     * @param {String} type
     * @default
     */
    color: '#FFFFFF',
    replacementColor: [255, 0, 0, 1],
    /**
     * Fragment source for the brightness program
     */
    fragmentSource: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform vec4 uLow;\n' +
        'uniform vec4 uHigh;\n' +
        'uniform vec4 uRep;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
        'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
        'if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n' +
        'gl_FragColor.rgb = uRep.rgb;\n' +   
        'gl_FragColor.a = uRep.a;\n' +
        '}\n' +
        '}',
    /**
     * distance to actual color, as value up or down from each r,g,b
     * between 0 and 1
     **/
    distance: 0.3,
    /**
     * For color to remove inside distance, use alpha channel for a smoother deletion
     * NOT IMPLEMENTED YET
     **/
    useAlpha: false,
    /**
     * Constructor
     * @memberOf fabric.Image.filters.RemoveWhite.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.color=#RRGGBB] Threshold value
     * @param {Number} [options.distance=10] Distance value
     */
    /**
     * Applies filter to canvas element
     * @param {Object} canvasEl Canvas element to apply filter to
     */
    applyTo2d: function (options) {
        var imageData = options.imageData,
            data = imageData.data, i,
            distance = this.distance * 255,
            r, g, b,
            source = new fabric.Color(this.color).getSource(),
            lowC = [
                source[0] - distance,
                source[1] - distance,
                source[2] - distance,
            ],
            highC = [
                source[0] + distance,
                source[1] + distance,
                source[2] + distance,
            ];

        for (i = 0; i < data.length; i += 4) {
            r = data[i];
            g = data[i + 1];
            b = data[i + 2];
            if (r > lowC[0] &&
                g > lowC[1] &&
                b > lowC[2] &&
                r < highC[0] &&
                g < highC[1] &&
                b < highC[2]) {
                data[i] = this.replacementColor[0];
                data[i + 1] = this.replacementColor[1];
                data[i + 2] = this.replacementColor[2];
                data[i + 3] = this.replacementColor[3];
            }
        }
    },
    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function (gl, program) {
        return {
            uLow: gl.getUniformLocation(program, 'uLow'),
            uHigh: gl.getUniformLocation(program, 'uHigh'),
            uRep: gl.getUniformLocation(program, 'uRep')
        };
    },
    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function (gl, uniformLocations) {
        var source = new fabric.Color(this.color).getSource(),
            distance = parseFloat(this.distance),
            lowC = [
                0 + source[0] / 255 - distance,
                0 + source[1] / 255 - distance,
                0 + source[2] / 255 - distance,
                1
            ],
            highC = [
                source[0] / 255 + distance,
                source[1] / 255 + distance,
                source[2] / 255 + distance,
                1
            ],
            repC = [
                this.replacementColor[0] / 255,
                this.replacementColor[1] / 255,
                this.replacementColor[2] / 255,
                this.replacementColor[3]
            ];
        gl.uniform4fv(uniformLocations.uLow, lowC);
        gl.uniform4fv(uniformLocations.uHigh, highC);
        gl.uniform4fv(uniformLocations.uRep, repC);
    },
    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function () {
        return extend(this.callSuper('toObject'), {
            color: this.color,
            replacementColor: this.replacementColor,
            distance: this.distance
        });
    }
});
/**
 * Returns filter instance from an object representation
 * @static
 * @param {Object} object Object to create an instance from
 * @param {Function} [callback] to be invoked after filter creation
 * @return {fabric.Image.filters.ReplaceColor} Instance of fabric.Image.filters.RemoveWhite
 */
fabric.Image.filters.ReplaceColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;

const ERASE_COLOR = 'rgb(255, 255, 255)'
fabric.PencilBrushCustom = fabric.util.createClass(fabric.PencilBrush, {
    createPath: function (pathData) {
        const path = new fabric.Path(pathData, {
            fill: null,
            stroke: this.color == 'rgba(0,0,0,0)' ? ERASE_COLOR : this.color,
            strokeWidth: this.width,
            strokeLineCap: this.strokeLineCap,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeLineJoin: this.strokeLineJoin,
            strokeDashArray: this.strokeDashArray,
            globalCompositeOperation: this.color == 'rgba(0,0,0,0)' ? 'destination-out' : 'source-over',
            selectable: false,
            hoverCursor: 'pointer',
            evented: false,
        });
        if (this.shadow) {
          this.shadow.affectStroke = true;
          path.shadow = new fabric.Shadow(this.shadow);
        }
  
        return path;
    },
})